// Single source of truth for the 2026 redesign tokens.
// See docs/design_handoff_eladore_redesign/README.md
export const COLORS = {
  green: '#3A4F41',
  greenDark: '#2C3E33',
  gold: '#B08D57',
  goldDark: '#96754A',
  goldLight: '#D9C7A7',
  goldText: '#80602E',
  goldOnDark: '#C6A96A',
  wine: '#7A2E3B',          // "Sale" nav item ONLY
  footerBg: '#23302A',
  footerText: '#F4F1EA',
  surfaceWarm: '#F1EDE4',
  surfacePanel: '#F7F5F1',
  borderHairline: '#ECE7DE',
  borderControl: '#D8D2C6',
  dividerWarm: '#E5E0D5',
  textPrimary: '#212121',
  textBody: '#5a5a52',
  textSecondary: '#757575',
  textWarmMuted: '#8a8374',
  textFaint: '#9e988a',
  strike: '#9e9e9e',
  checkboxStroke: '#B7B0A2',
};

export const FONTS = {
  heading: "'Playfair Display', serif",
  body: "'Lato', sans-serif",
};

export const BUTTON_TEXT_SX = {
  textTransform: 'uppercase',
  fontSize: '0.8125rem',
  fontWeight: 700,
  letterSpacing: '1.5px',
};

export const STICKY_BAR_SX = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  bgcolor: '#FFFFFF',
  borderTop: `1px solid ${COLORS.borderHairline}`,
  boxShadow: '0 -6px 20px rgba(0,0,0,0.08)',
  p: '12px 16px',
  zIndex: 1200,
};

export const HOVER_SCALE_IMG_SX = {
  '& img': { transition: 'transform 0.4s ease' },
  '&:hover img': { transform: 'scale(1.04)' },
};
